<template>
  <div class="productApplication">
    <el-row>
      <el-col>
        <el-form :inline="true" style="margin: 0;" :model="searchForm" ref="searchForm" @keyup.enter.native="queryList"
          size="medium">
          <el-form-item label="申请日期：">
            <el-date-picker v-model="searchForm.DISINFECT_TIME" type="date" placeholder="选择申请日期"
              value-format="yyyy-MM-dd" style="width: 200px">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.PRODUCT_NAME"></el-input>
          </el-form-item>
          <el-form-item label="团餐公司：">
            <el-select v-model="searchForm.TC_ID" placeholder="请选择" clearable>
              <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核状态：">
            <el-select v-model="searchForm.AUDIT_STATUS" placeholder="请选择" clearable>
              <el-option v-for="item in auditStatusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-bottom: 10px">
      <el-button size="medium" type="primary" @click="queryList">筛选</el-button>
      <el-button size="medium" @click="addVisible = true">新增申请</el-button>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="产品名称" prop="NAME"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="规格" prop="SPECIFICATION"></el-table-column>
          <el-table-column label="品牌" prop="BRAND"></el-table-column>
          <el-table-column label="报价" prop="PRODUCT_PRICE"></el-table-column>
          <el-table-column label="库存量" prop="PRODUCT_COUNT"></el-table-column>
          <el-table-column label="团餐公司" prop="TC_NAME"></el-table-column>
          <el-table-column label="提交时间" prop="CREATE_TIME"></el-table-column>
          <el-table-column label="状态" prop="AUDIT_STATUS">
            <template slot-scope="scope">
              <span v-if="scope.row.AUDIT_STATUS === 0">待审核</span>
              <span v-if="scope.row.AUDIT_STATUS === 1">已上架</span>
              <span v-if="scope.row.AUDIT_STATUS === 2">已拒绝</span>
            </template>
          </el-table-column>
          <el-table-column label="拒绝理由" prop="REFUSE_REASON"></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" @click="openEdit(scope.row)" v-if="scope.row.AUDIT_STATUS !== 1">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="queryData" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <!--    申请模态框-->
    <el-dialog title="新增申请上架" :visible.sync="addVisible" width="1000px" center>
      <el-form ref="addForm" :model="addForm" label-width="100px" :rules="rules" size="small">
        <el-row>
          <el-col :span="11">
            <el-form-item label="团餐公司：" prop="TC_ID">
              <el-select v-model="addForm.TC_ID" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="品牌：" prop="BRAND">
              <el-input v-model="addForm.BRAND"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="品名：" prop="NAME">
              <el-input @input="handleInputChange" type="text" v-model="addForm.NAME"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="规格：" prop="SPECIFICATION">
              <el-input v-model="addForm.SPECIFICATION"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="大类：" prop="FIRST_CATALOG_CODE">
              <el-select v-model="addForm.FIRST_CATALOG_CODE" @change="addGetSecond()" style="width: 100%;">
                <el-option v-for="item in firstLists" :key="item.INNER_CODE" :label="item.NAME" :value="item.INNER_CODE">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="二类：" prop="SECOND_CATEGORY_CODE">
              <el-select v-model="addForm.SECOND_CATEGORY_CODE" style="width: 100%;">
                <el-option v-for="item in secondLists" :key="item.INNER_CODE" :label="item.NAME" :value="item.INNER_CODE">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="单位：" prop="TYPE_UNIT">
              <el-input v-model="addForm.TYPE_UNIT"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="库存量：" prop="PRODUCT_COUNT">
              <el-input v-model="addForm.PRODUCT_COUNT"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="报价：" prop="PRODUCT_PRICE">
              <el-input v-model="addForm.PRODUCT_PRICE"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="资质上传：" prop="PIC_URL">
              <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
                :on-remove="handleRemove" name="SupplierQualify" multiple :file-list="fileList">
                <el-button type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button @click="submitAdd()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog :visible.sync="editVisible" center title="修改申请上架" width="1000px">
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="100px" size="small">
        <el-row>
          <el-col :span="11">
            <el-form-item label="团餐公司：" prop="TC_NAME">
              <el-input v-model="this.editForm.TC_NAME" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="品牌：" prop="BRAND">
              <el-input v-model="editForm.BRAND"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="品名：" prop="NAME">
              <el-input v-model="editForm.NAME" @input="edithandleInputChange" type="text"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="单位：" prop="TYPE_UNIT">
              <el-input v-model="editForm.TYPE_UNIT"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="规格：" prop="SPECIFICATION">
              <el-input v-model="editForm.SPECIFICATION"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="库存量：" prop="PRODUCT_COUNT">
              <el-input v-model="editForm.PRODUCT_COUNT"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="大类：" prop="FIRST_CATALOG_CODE">
              <el-select v-model="editForm.FIRST_CATALOG_CODE" @change="getSecond()" style="width: 100%;">
                <el-option v-for="item in firstLists" :key="item.INNER_CODE" :label="item.NAME" :value="item.INNER_CODE">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="二类：" prop="SECOND_CATEGORY_CODE">
              <el-select v-model="editForm.SECOND_CATEGORY_CODE" :disabled="!secondLists.length" style="width: 100%;">
                <el-option v-for="item in secondLists" :key="item.INNER_CODE" :label="item.NAME" :value="item.INNER_CODE">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="报价：" prop="PRODUCT_PRICE">
              <el-input v-model="editForm.PRODUCT_PRICE"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="11">
            <el-form-item label="资质上传：" prop="editForm.PIC_URL" ref="addFormPic" v-model="addFormPic">
              <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
                :on-remove="handleRemove" :name="this.addFormPic.image" :multiple="false" :file-list="fileList"
                :limit="1">
                <el-button type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取消</el-button>
        <el-button @click="submitEdit()">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getLKDFirstKindFun, getLKDSecondKindFun } from 'api/skuManage';
import { queryCustomerFun } from 'api/DSOrder';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';
import util from '@/assets/common/util';

let SUPPLIER_ID;

export default {
  data() {
    return {
      // 分页
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      auditStatusList: [{
        value: '0',
        label: '未审核',
      }, {
        value: '1',
        label: '审核通过',
      }, {
        value: '2',
        label: '审核拒绝',
      }],
      companys: [],
      firstLists: [], // 一级大类
      secondLists: [], // 二级大类
      searchForm: {},
      tableData: [],
      editForm: {
        FIRST_CATALOG_CODE: '',
        SECOND_CATEGORY_CODE: '',
        ID: '',
        BRAND: '',
        NAME: '',
        TYPE_UNIT: '',
        SPECIFICATION: '',
        PRODUCT_COUNT: '',
        PRODUCT_PRICE: '',
      },
      fileList: [],
      addForm: {
        TC_ID: '',
        BRAND: '',
        NAME: '',
        TYPE_UNIT: '',
        SPECIFICATION: '',
        PRODUCT_COUNT: '',
        PRODUCT_PRICE: '',
        FIRST_CATALOG_CODE: '',
        SECOND_CATEGORY_CODE: '',
      },
      addVisible: false,
      editVisible: false,
      rules: {
        TC_ID: [{ required: true, message: '请选择团餐公司', trigger: 'change' }],
        FIRST_CATALOG_CODE: [{ required: true, message: '请选择大类', trigger: 'blur' }],
        SECOND_CATEGORY_CODE: [{ required: true, message: '请选择二类', trigger: 'blur' }],
        NAME: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        TYPE_UNIT: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        PRODUCT_COUNT: [{ required: true, message: '请输入库存量', trigger: 'blur' }],
        PRODUCT_PRICE: [{ required: true, message: '请输入价格', trigger: 'blur' }],
      },
    };
  },
  methods: {
    // 空格自动删除
    handleInputChange() {
      this.$nextTick(() => {
        if (/\s/.test(this.addForm.NAME)) {
          this.addForm.NAME = this.addForm.NAME.replace(/\s/g, '');
        }
      });
    },
    edithandleInputChange() {
      this.$nextTick(() => {
        if (/\s/.test(this.editForm.NAME)) {
          this.editForm.NAME = this.editForm.NAME.replace(/\s/g, '');
        }
      });
    },
    // 打开页面获取团餐公司
    getTcCompanyList() {
      queryCustomerFun().then((result) => {
        if (result.length !== 0) {
          this.companys = result[0].company;
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    queryList() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      const params = {
        SERVICE_ID: '10202',
        OTYPE: 970,
        SUPPLIER_ID,
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.DISINFECT_TIME) {
        params.DISINFECT_TIME = this.searchForm.DISINFECT_TIME;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.AUDIT_STATUS) {
        params.AUDIT_STATUS = this.searchForm.AUDIT_STATUS;
      }

      http.post(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.tableData = result[0].OP_ROLE;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 打开修改模态框
    openEdit(row) {
      this.editForm = {
        ...row,
        FIRST_CATALOG_CODE: Math.floor(row.SECOND_CATEGORY_CODE / 1000),
      };
      this.querySecondCatalog();
      this.editVisible = true;
    },
    // 申请新增
    submitAdd() {
      if (document.body.style.cursor != 'wait') {
        document.body.style.cursor = 'wait';
        this.$refs.addForm.validate((vallid) => {
          try {
            if (vallid) {
              if (!validation.价格正数0验证(this.addForm.PRODUCT_PRICE)) {
                this.$message.show({ text: '请输入正确的价格', type: 'warning' });
                document.body.style.cursor = 'default';
                return false;
              }
              if (util.JudgmentUnit(this.addForm.TYPE_UNIT) ? !validation.数量正数0验证(this.addForm.PRODUCT_COUNT) : !validation.数量整数正数0验证(this.addForm.PRODUCT_COUNT)) {
                this.$message.show({ text: '请输入正确的库存量', type: 'warning' });
                document.body.style.cursor = 'default';
                return false;
              }
              const params = {
                SERVICE_ID: '10202',
                OTYPE: 940,
                SUPPLIER_ID,
                TC_ID: this.addForm.TC_ID,
                NAME: this.addForm.NAME,
                BRAND: this.addForm.BRAND,
                SPECIFICATION: this.addForm.SPECIFICATION,
                TYPE_UNIT: this.addForm.TYPE_UNIT.toUpperCase() == 'KG' ? 'KG' : this.addForm.TYPE_UNIT,
                PRODUCT_COUNT: this.addForm.PRODUCT_COUNT,
                PRODUCT_PRICE: this.addForm.PRODUCT_PRICE,
                SECOND_CATEGORY_CODE: this.addForm.SECOND_CATEGORY_CODE,
                FILE_URL: this.fileList.map((item) => item.response.file_name),
              };
              http.post(params).then((result) => {
                this.$message.show({ text: '新增成功', type: 'success' });
                this.cancel();
                this.queryList();
                document.body.style.cursor = 'default';
              }).catch((error) => {
                this.$message.show({ text: error, type: 'error' });
              });
            } else {
              document.body.style.cursor = 'default';
            }
          } catch (e) {
            document.body.style.cursor = 'default';
          }
        });
      }
    },
    cancel() {
      this.editForm = {};
      this.addForm = {};
      this.editVisible = false;
      this.addVisible = false;
      this.fileList = [];
    },
    // 修改
    submitEdit() {
      const params = {
        SERVICE_ID: '10202',
        OTYPE: 950,
        SUPPLIER_ID,
        ID: this.editForm.ID,
        NAME: this.editForm.NAME,
        BRAND: this.editForm.BRAND,
        SPECIFICATION: this.editForm.SPECIFICATION,
        TYPE_UNIT: this.editForm.TYPE_UNIT,
        PRODUCT_COUNT: this.editForm.PRODUCT_COUNT,
        PRODUCT_PRICE: this.editForm.PRODUCT_PRICE,
        SECOND_CATEGORY_CODE: this.editForm.SECOND_CATEGORY_CODE,
        PIC_URL: this.editForm.PIC_URL,
      };
      if (!validation.价格正数0验证(this.editForm.PRODUCT_PRICE)) {
        this.$message.show({ text: '请输入正确的价格', type: 'warning' });
        document.body.style.cursor = 'default';
        return false;
      }
      if (util.JudgmentUnit(this.editForm.TYPE_UNIT) ? !validation.数量正数0验证(this.editForm.PRODUCT_COUNT) : !validation.数量整数正数0验证(this.editForm.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入正确的库存量', type: 'warning' });
        document.body.style.cursor = 'default';
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });

        this.cancel();
        this.queryList();

        document.body.style.cursor = 'default';
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    queryFirstCatalog() {
      const param = {
        PAGEINDEX: 0,
        PAGESIZE: 1000,
      };
      // 获取LKD系统一级二级大类
      getLKDFirstKindFun(param).then((result) => {
        this.firstLists = result.length > 0 ? result[0].OP_ROLE : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySecondCatalog() {
      const param = {
        PAGEINDEX: 0,
        PAGESIZE: 1000,
        FIRST_CATALOG_CODE: this.editForm.FIRST_CATALOG_CODE,
      };
      getLKDSecondKindFun(param).then((result) => {
        this.secondLists = result.length > 0 ? result[0].OP_ROLE : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addquerySecondCatalog() {
      const param = {
        PAGEINDEX: 0,
        PAGESIZE: 1000,
        FIRST_CATALOG_CODE: this.addForm.FIRST_CATALOG_CODE,
      };
      getLKDSecondKindFun(param).then((result) => {
        this.secondLists = result.length > 0 ? result[0].OP_ROLE : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getSecond() {
      this.editForm.SECOND_CATEGORY_CODE = '';
      this.querySecondCatalog();
    },
    addGetSecond() {
      this.addForm.SECOND_CATEGORY_CODE = '';
      this.addquerySecondCatalog();
    },

  },
  created() {
    SUPPLIER_ID = Number(sessionStorage.getItem('tcId'));
    this.queryFirstCatalog();
    this.getTcCompanyList();
    this.queryList();
  },
};
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/components/SKUManage/productApplication.vue